import { useEffect, useRef } from 'react'
import { useAuth } from '@/store/auth.store'
import { useOrganizationStore } from '@/store/organization.store'
import { identify, resetAnalytics } from '@/lib/analytics'

export function useAnalyticsIdentity(): void {
  const user = useAuth(s => s.user)
  const isAuthenticated = useAuth(s => s.isAuthenticated)
  const orgId = useOrganizationStore(s => s.currentOrganization?.id ?? null)
  const lastKey = useRef<string | null>(null)

  useEffect(() => {
    if (!isAuthenticated || !user) {
      if (lastKey.current !== null) {
        resetAnalytics()
        lastKey.current = null
      }
      return
    }

    const key = `${user.id}::${orgId ?? ''}`
    if (lastKey.current === key) return
    lastKey.current = key

    identify(
      {
        id: user.id,
        email: user.email,
        displayName: user.displayName,
        role: user.role,
        createdAt: user.createdAt,
      },
      orgId,
    )
  }, [isAuthenticated, user, orgId])
}
